import axios from "axios";

const url = "https://achtin-tst.minka.io/v1";
const config = {
  headers: {
    api_key: "5b481fc2ae177010e197026b39c58cdb000f4c3897e841714e82c84c"
  }
};

function get(path) {
  return axios.get(url + path, config);
}

function post(path, data) {
  return axios.post(url + path, data, config);
}

export default { get, post };



// WEBPACK FOOTER //
// ./src/Http/Http.js